export default __webpack_public_path__ + "static/942-b315ed487793b1cdfa5ee482540b419f.gif";